export default __webpack_public_path__ + "static/media/aboutUs.ea87f6f0.jpg";